import Env from '../BsGetEnv'
let domainName
if(Env.isEnVlocal){
    domainName = ''
}else if (Env.isEnvOnline) {
    domainName = 'https://capis.didapinche.com'
} else if (Env.isEnvECS) {
    domainName = 'https://capis-ecs.didapinche.com'
} else {
    domainName = 'https://capis-test.didapinche.com'
}
export default domainName;